import { useThemeStore } from "../../lib/stores/theme";
import { useStoreConfig } from "../../features/config/queries";

export interface BrandLogoProps {
  variant?: "icon" | "full";
  className?: string;
  /** Override the site's light/dark preference — for contexts (like a fixed-dark hero) that always need one specific logo variant. */
  forceTheme?: "light" | "dark";
}

export function BrandLogo({ variant = "icon", className, forceTheme }: BrandLogoProps) {
  const siteTheme = useThemeStore((s) => s.resolvedTheme);
  const theme = forceTheme ?? siteTheme;
  const { data: config } = useStoreConfig();
  // An admin-uploaded logo replaces both the icon and full variants (and
  // both light/dark theme files) — there's just one uploaded image, unlike
  // the four bundled theme/variant PNGs it falls back to when unset.
  const src = config?.logoUrl || (variant === "icon" ? `/brand/icon-${theme}.png` : `/brand/logo-${theme}.png`);

  return <img src={src} alt={config?.storeName || "Latif General Store"} className={className} />;
}
